import axios from 'axios';
import { REFERRAL_TYPES } from '@upsolve/shared';
import { get } from 'lodash';

import getGAClientId from '../analytics/getGAClientId';

export default async function submitLead({ name, email, employed, phoneNumber, type = 'bankruptcy', zipcode }) {
  const gaClientId = await getGAClientId();
  if (type === 'bankruptcy') {
    return axios.post(`${UPSOLVE_API_URL}/v1/filers/disqualify`, {
      filer: {
        name,
        email,
        phoneNumber,
        zipcode,
        segment: {
          anonymousId: get(window, 'analytics.user') != null ? window.analytics.user().anonymousId() : undefined,
          traits: get(window, 'analytics.user') != null ? window.analytics.user().traits() : undefined,
          gaClientId,
        },
      },
      referrals: [REFERRAL_TYPES.BANKRUPTCY],
    });
  }
  if (type === 'debtManagementPlan') {
    return axios.post(`${UPSOLVE_API_URL}/v1/filers/refer`, {
      filer: {
        name,
        email,
        phoneNumber,
        segment: {
          anonymousId: get(window, 'analytics.user') != null ? window.analytics.user().anonymousId() : undefined,
          traits: get(window, 'analytics.user') != null ? window.analytics.user().traits() : undefined,
          gaClientId,
        },
        traits: {
          employed,
        },
        referralTypes: [REFERRAL_TYPES.DEBT_MANAGEMENT_PLAN],
      },
    });
  }
}
